import {supportNative, getErrorFactory, logError} from './util';


const document = window.document;
const zzc = window.zzc;


/**
 * 设置title
 *
 * @export
 * @param {string} [title='行程助手']
 * @param {any} [options={}] 可选参数
 * * type {string}:  显示的类型
 * * color {string}:  颜色（#ffffff）
 * * isReflected {boolean}:  是否可点击
 * * webViewUrl {string}:  点击后的跳转URL（弃用，请用事件监听代替）
 * @returns
 */
export default function setTitle(title = '行程助手', options = {}) {
  document.title = title;

  let errorFactory = getErrorFactory('setTitle');

  if (!supportNative('base_webviewTitle')) {
    return logError(errorFactory('不支持zzcjsbridge'));
  }

  zzc.call('base_webviewTitle', {
    ...options,
    title,
    complete: function (res) {
      if (res.state) {
        logError(errorFactory(res.message));
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/setTitle.js